jQuery('body').ready( function() {
    var current_url = location.protocol + '//' + location.host + location.pathname;
    var btns = jQuery('.wp-block-button__link.has-dark-color.has-text-color.wp-element-button');
    btns.each( function() {
        if ( jQuery(this).attr('href') == current_url ) {
            jQuery(this).addClass('current');
        }
    } );
} );